import Vue from 'vue'
import VueRouter from 'vue-router'
import { hasToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', guest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { title: '注册', guest: true }
  },
  {
    path: '/apply',
    name: 'Apply',
    component: () => import('@/views/Apply.vue'),
    meta: { title: '会员申请', requiresAuth: true }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '会员首页', requiresAuth: true }
  },
  {
    path: '/apply-info',
    name: 'ApplyInfo',
    component: () => import('@/views/ApplyInfo.vue'),
    meta: { title: '申请信息', requiresAuth: true }
  },
  {
    path: '/security',
    name: 'Security',
    component: () => import('@/views/Security.vue'),
    meta: { title: '安全中心', requiresAuth: true }
  },
  {
    path: '/notice-detail',
    name: 'NoticeDetail',
    component: () => import('@/views/NoticeDetail.vue'),
    meta: { title: '通知详情', requiresAuth: true }
  },
  {
    path: '/certificate-view',
    name: 'CertificateView',
    component: () => import('@/views/CertificateView.vue'),
    meta: { title: '电子会员证', requiresAuth: true }
  },
  {
    path: '/vote/:id',
    name: 'Vote',
    component: () => import('@/views/Vote.vue'),
    meta: { title: '投票问卷', requiresAuth: true, voteFlow: true }
  },
  {
    path: '/vote-success',
    name: 'VoteSuccess',
    component: () => import('@/views/VoteSuccess.vue'),
    meta: { title: '投票成功', requiresAuth: true, voteFlow: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

function isSafeInternalPath(path) {
  return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')
}

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
    ? `${to.meta.title} - 世界华人医师协会`
    : '世界华人医师协会 - 会员系统'

  const loggedIn = hasToken()

  if (to.meta.requiresAuth && !loggedIn) {
    const query = {
      redirect: to.fullPath
    }
    if (to.meta.voteFlow) {
      query.voteLogin = '1'
    }
    next({ path: '/login', replace: true, query })
    return
  }

  if (to.meta.guest && loggedIn && (to.path === '/login' || to.path === '/register')) {
    const redirect = to.query.redirect
    if (isSafeInternalPath(redirect)) {
      next({ path: redirect, replace: true })
      return
    }
    next({ path: '/home', replace: true })
    return
  }

  next()
})

export default router
